module.exports = __webpack_public_path__ + "img/empty-table.4928f2f8.png";